import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { OuterWrapper, InnerWrapper, CloseIcon } from './TooltipContent.styles';

const TooltipPortal = ({ children }) => {
  const tooltipRoot = document.body;
  const el = document.createElement('div');

  useEffect(() => {
    tooltipRoot.appendChild(el);

    return () => {
      try {
        tooltipRoot.removeChild(el);
      } catch (e) {
        // node was already removed
      }
    };
  }, []);

  return createPortal(children, el);
};

const TooltipContent = ({
  children,
  closeTooltip,
  contentWidth,
  direction,
  arrowPosition,
  show,
  position,
  offsetTooltip,
  className,
  persist
}) => {
  return show && (
    <TooltipPortal>
      <OuterWrapper
        contentWidth={contentWidth}
        direction={direction}
        arrowPosition={arrowPosition}
        position={position}
        offsetTooltip={offsetTooltip}
        onClick={e => closeTooltip(e, true)}
      >
        <InnerWrapper
          direction={direction}
          arrowPosition={arrowPosition}
          className={className}
        >
          {persist && <CloseIcon width={12} height={12} />}
          {children}
        </InnerWrapper>
      </OuterWrapper>
    </TooltipPortal>
  );
};

TooltipContent.propTypes = {
  children: PropTypes.node.isRequired,
  persist: PropTypes.bool,
  closeTooltip: PropTypes.func,
  contentWidth: PropTypes.number,
  direction: PropTypes.string,
  arrowPosition: PropTypes.string,
  show: PropTypes.bool,
  position: PropTypes.shape({}),
  offsetTooltip: PropTypes.shape({}),
  className: PropTypes.string
};

TooltipContent.defaultProps = {
  closeTooltip: f => f,
  persist: false,
  contentWidth: 250,
  direction: 'down',
  arrowPosition: 'right',
  show: false,
  position: {
    rect: {},
    scrollTop: 0,
    scrollLeft: 0
  },
  offsetTooltip: {},
  className: ''
};

export default TooltipContent;
